import { render, staticRenderFns } from "./UpdateItemModal.vue?vue&type=template&id=a559e04a&"
import script from "./UpdateItemModal.vue?vue&type=script&lang=js&"
export * from "./UpdateItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports